import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
const useProductAR = () => {
  const $ = _c(12);
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData
  } = usePDPBasicDetails();
  const [isARsupported, setIsARsupported] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isARsupported) {
    t0 = () => {
      const targetElement = document.querySelector("a");
      if (targetElement?.relList?.supports("ar") && !isARsupported) {
        setIsARsupported(true);
      }
    };
    t1 = [isARsupported];
    $[0] = isARsupported;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = isARsupported ? basicData?.custom_properties?.ar_asset : null;
  const t3 = isARsupported ? basicData?.custom_properties?.ar_asset_upholstery : null;
  const t4 = basicData?.meta?.price?.final_price || 0;
  let t5;
  if ($[3] !== isARsupported || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      isARsupported,
      arAsset: t2,
      arAssetUpholstery: t3,
      arPrice: t4
    };
    $[3] = isARsupported;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== basicError || $[9] !== basicLoading || $[10] !== t5) {
    t6 = {
      loading: basicLoading,
      error: basicError,
      data: t5
    };
    $[8] = basicError;
    $[9] = basicLoading;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default useProductAR;